import React, { useRef } from 'react';

function QSARModule({ onSubmit }) {
  const fileRef = useRef();

  const handleSubmit = () => {
    const file = fileRef.current.files[0];
    if (!file) return alert("请上传描述符或特征表（CSV/TSV）");

    const formData = new FormData();
    formData.append('qsarFile', file);
    onSubmit('QSAR建模', formData, 'qsar');
  };

  return (
    <div className="flex flex-col h-full">
      <input
        type="file"
        accept=".csv,.tsv,.xlsx"
        ref={fileRef}
        className="form-input"
      />

      {/* 按钮始终底部对齐 */}
      <div className="flex justify-center mt-auto pt-4">
        <button onClick={handleSubmit} className="btn-primary">提交任务</button>
      </div>
    </div>
  );
}

export default QSARModule;

